(function($) {
    $.Zoomer = function(options) {
        var defaults = {
            element: null,
            alttext: "",
            smoothLevel: 6,
            placeHolder: null,
            zoomwidth: null,
            zoomheight: null,
            zoomdesktopevent: "click",
            onzoom: function() {},
            ontouch:function(){},
            onzoomout: function() {}
        }
        var _inst = this;
        _inst.transitioning = false;
        _inst.settings = {}
        _inst.zoomStatus = false;
        _inst.zoomButtonPress = false;
        _inst.arrPreloaded = [];
        _inst.big = null;
        _inst.small = null;
        _inst.smallWrapper = null;
        _inst.bigWrapper = null;
        _inst.bigPrepared = false;
        _inst.smallPrepared = false;
        _inst.smallSize = {
            width: null,
            height: null
        };
        _inst.current = {
            left: 0,
            top: 0
        };
        _inst.bigSize = {
            width: null,
            height: null
        };
        _inst.usetouch = false;
        /*if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            _inst.usetouch = true;
        }*/
        var init = function() {
            _inst.settings = $.extend({}, defaults, options);
            //console.log("_inst.usetouch"  +  _inst.settings.usetouch)
            if (_inst.settings.usetouch) {
                _inst.settings.ontouch.call(_inst,_inst.settings.element)
                return;
            }

            if (!_inst.settings.element) {
                console.log("please pass an element property");
                return
            };
            _inst.small = _inst.settings.element;
            if(_inst.settings.alttext!==""){
                _inst.small.attr("alt", _inst.settings.alttext);
            }
            

            if(_inst.small.length >0){
                if (!_inst.small[0].complete) {
                    _inst.small.bind('load', function() {
                        
                        prepareSmallImage();
                    });
                } else {
                    prepareSmallImage();
                }
    
            }
            
            var src = _inst.settings.placeHolder || _inst.small.attr('placeholder');
            var img = new Image();
            img.src = src;


            if(_inst.settings.alttext!==""){
                $(img).attr("alt", _inst.settings.alttext);
            }

            _inst.big = $(img).css({
                position: 'absolute',
                top: 0,
                left: 0,
                cursor: 'crosshair'
            }).hide();
            if (!_inst.big[0].complete) {
                _inst.big.bind('load', function() {
                    prepareBigImage();
                });
            } else {
                prepareBigImage();
            }
        };
        var prepareSmallImage = function() {
            _inst.small.wrap('<div class="zoomer-wrapper"></div>');
            _inst.smallWrapper = _inst.small.parent();
            $.each(['margin', 'left', 'top', 'bottom', 'right', 'float', 'clear', 'border', 'padding'], function(i, p) {
                var style;
                if ($.inArray(p, ['left', 'top', 'bottom', 'right']) != -1) {
                    style = getComputedStyle(_inst.small[0], p);
                } else {
                    style = _inst.small.css(p);
                }
                if (p == 'margin' && style == 'auto') return;
                var dflt = 'auto';
                if ($.inArray(p, ['float', 'clear', 'border']) != -1) dflt = 'none';
                if (p == 'padding') dflt = '0';
                try {
                    _inst.small.css(p, dflt);
                    _inst.smallWrapper.css(p, style);
                } catch (e) {};
            });
            _inst.smallWrapper.css({
                width: _inst.small[0].offsetWidth,
                height: _inst.small[0].offsetHeight,
                position: 'relative',
                overflow: 'hidden'
            });
            _inst.smallSize = {
                width: _inst.small[0].width,
                height: _inst.small[0].height
            };
            if (_inst.bigPrepared) {
                imageReady();
            } else {
                _inst.smallPrepared = true;
            }
            _inst.small.unbind('load')
        };
        var prepareBigImage = function() {
            _inst.bigSize = {
                width: _inst.big[0].width,
                height: _inst.big[0].height
            };
            if (_inst.smallPrepared) {
                imageReady();
            } else {
                _inst.bigPrepared = true;
            }
        };
        var imageReady = function() {
            if (_inst.small.hasClass("imageready")) {
                return;
            }
            _inst.big.appendTo(_inst.smallWrapper);
            _inst.big.wrap('<div class="zoomer-wrapper-big"></div>');
            _inst.big.parent().append("<div class='reg'>&nbsp;</div>")
            _inst.big.parent().find(".reg").css({
                "height": "1px",
                "width": "1px",
                "background": "#000",
                "position": "absolute",
                "top": "50%",
                "left": "50%",
                "visibility": "hidden"
            })
            _inst.big.parent().append("<div class='zoompreloader'><img src='" + _inst.small.attr("preloader") + "'></div>")
            _inst.big.parent().find(".zoompreloader").hide();
            _inst.bigWrapper = _inst.big.parent();
            _inst.bigWrapper.css({
                position: 'absolute',
                overflow: 'hidden',
                top: _inst.small.offset().top - _inst.smallWrapper.offset().top - parseInt(_inst.smallWrapper.css('border-top-width'), 10) || 0,
                left: _inst.small.offset().left - _inst.smallWrapper.offset().left - parseInt(_inst.smallWrapper.css('border-left-width'), 10) || 0,
                width: _inst.small[0].offsetWidth,
                height: _inst.small[0].offsetHeight
            })
            if (_inst.settings.zoomdesktopevent == "hover") {
                _inst.bigWrapper.mouseenter($.proxy(preloadZoom, this));
                _inst.bigWrapper.mouseleave($.proxy(_inst.stopZoom, this))
            } else {
                _inst.bigWrapper.mouseup($.proxy(preloadZoom, this));
                _inst.bigWrapper.mouseleave($.proxy(_inst.stopZoom, this))
            }
            if (_inst.usetouch) {
                _inst.bigWrapper.bind('touchmove', function(event) {
                    event.preventDefault();
                    //_inst.settings.onzoom.call(_inst)
                   // console.log(event.touches[0].pageX)
                });
            } else {
                _inst.bigWrapper.mousemove($.proxy(_inst.move, this));
            }
            _inst.small.addClass("imageready")
        }
        this.move = function(event) {
            if (_inst.usetouch) {
                event.preventDefault();

            }
            if (_inst.zoomButtonPress) {
                _inst.dstPos = {
                    x: $(".reg").offset().left,
                    y: $(".reg").offset().top
                };
            } else {
                if (_inst.usetouch) {
                    _inst.dstPos = {
                        x: event.touches[0].pageX,
                        y: event.touches[0].pageY
                    };
                } else {
                    _inst.dstPos = {
                        x: event.pageX,
                        y: event.pageY
                    };
                }
            }
            if (!_inst.dstPos.x) {
                _inst.dstPos = {
                    x: $(".reg").offset().left,
                    y: $(".reg").offset().top
                };
            }
        }
        var preloadZoom = function(e) {
            var srcbig = _inst.small.attr("big")
            var imgZoom = new Image();
            if (!findCachedImages(srcbig)) {
                _inst.big.parent().find(".zoompreloader").show();
            }
            imgZoom.onload = function() {
                _inst.big.parent().find(".zoompreloader").hide();
                _inst.big[0].src = srcbig
                _inst.startZoom(e)
            }
            imgZoom.src = srcbig;
        }
        var findCachedImages = function(imgurl) {
            var found = false;
            for (var i = 0; i < _inst.arrPreloaded.length; i++) {
                if (_inst.arrPreloaded[i] == imgurl) {
                    found = true;
                }
            }
            if (!found) {
                _inst.arrPreloaded.push(imgurl)
            }
            return found;
        }
        var getComputedStyle = function(element, property) {
            if (element.currentStyle) return element.currentStyle[property];
            var computed = document.defaultView.getComputedStyle(element, null);
            return (computed) ? computed.getPropertyValue(property) : null;
        };
        this.stopZoom = function(e) {
            if (_inst.transitioning) {
                return;
            }
            _inst.transitioning = true
            clearInterval(_inst.timer);
            _inst.big.stop().animate({
                'height': _inst.smallSize.height + 'px',
                'width': _inst.smallSize.width + 'px',
                'top': '0px',
                'left': '0px'
            }, 300, function() {
                _inst.big.hide();
                _inst.settings.onzoomout.call(_inst)
                _inst.transitioning = false;
                _inst.zoomStatus = false;
                _inst.zoomButtonPress = false
            });
        }
        this.startZoom = function(e) {
            if (_inst.transitioning) {
                return;
            }
            _inst.transitioning = true
            if (!_inst.zoomStatus) {
                _inst.settings.onzoom.call(_inst)
                _inst.position = _inst.small.offset();
                var x = e.pageX - _inst.small[0].offsetLeft;
                var y = e.pageY - _inst.small[0].offsetTop;
                _inst.ratio = {
                    x: 1 - _inst.settings.zoomwidth / _inst.smallSize.width,
                    y: 1 - _inst.settings.zoomheight / _inst.smallSize.height
                };
                _inst.current = {
                    left: parseFloat(_inst.big.css('left'), 10),
                    top: parseFloat(_inst.big.css('top'), 10)
                };
                _inst.big.css({
                    width: _inst.small[0].width,
                    height: _inst.small[0].height
                })
                _inst.big.show();
                if (_inst.settings.zoomdesktopevent == "click") {
                    _inst.big.stop().animate({
                        'height': _inst.settings.zoomheight + "px",
                        'width': _inst.settings.zoomwidth + "px",
                        'left': parseInt((_inst.dstPos.x - _inst.position.left) * _inst.ratio.x, 10) + "px",
                        'top': parseInt((_inst.dstPos.y - _inst.position.top) * _inst.ratio.y, 10) + "px"
                    }, 300, function() {
                        _inst.current.left = parseInt((_inst.dstPos.x - _inst.position.left) * _inst.ratio.x, 10)
                        _inst.current.top = parseInt((_inst.dstPos.y - _inst.position.top) * _inst.ratio.y, 10)
                        _inst.timer = setInterval($.proxy(zoom, _inst), 10);
                        _inst.zoomStatus = true;
                        _inst.zoomButtonPress = false;
                        _inst.transitioning = false
                    });
                } else {
                    _inst.big.css({
                        'height': _inst.settings.zoomheight + "px",
                        'width': _inst.settings.zoomwidth + "px",
                        'left': parseInt((_inst.dstPos.x - _inst.position.left) * _inst.ratio.x, 10) + "px",
                        'top': parseInt((_inst.dstPos.y - _inst.position.top) * _inst.ratio.y, 10) + "px"
                    })
                    _inst.current.left = parseInt((_inst.dstPos.x - _inst.position.left) * _inst.ratio.x, 10)
                    _inst.current.top = parseInt((_inst.dstPos.y - _inst.position.top) * _inst.ratio.y, 10)
                    _inst.timer = setInterval($.proxy(zoom, _inst), 10);
                    _inst.zoomStatus = true;
                    _inst.zoomButtonPress = false;
                    _inst.transitioning = false;
                }
            } else {
                clearInterval(_inst.timer);
                _inst.transitioning = true;
                _inst.big.stop().animate({
                    'height': _inst.smallSize.height + 'px',
                    'width': _inst.smallSize.width + 'px',
                    'top': '0px',
                    'left': '0px'
                }, 300, function() {
                    _inst.big.hide();
                    _inst.settings.onzoomout.call(_inst)
                    _inst.zoomStatus = false;
                    _inst.zoomButtonPress = false
                    _inst.transitioning = false;
                });
            }
        }
        var zoom = function() {
            if (!_inst.dstPos) return;
            var steps = _inst.settings.smoothLevel;
            var dst = {
                left: parseInt((_inst.dstPos.x - _inst.position.left) * _inst.ratio.x, 10),
                top: parseInt((_inst.dstPos.y - _inst.position.top) * _inst.ratio.y, 10)
            };
            _inst.current.left -= (_inst.current.left - dst.left) / steps;
            _inst.current.top -= (_inst.current.top - dst.top) / steps;
            _inst.big.css(_inst.current);
        }
        this.setOpacity = function(opacitylevel) {
            _inst.small.css("opacity", opacitylevel);
        };
        this.setZoomStatus = function(boolStatus) {
            _inst.zoomStatus = boolStatus;
        };
        this.getZoomStatus = function() {
            return _inst.zoomStatus;
        };
        init();
    }
})(jQuery);